module.exports = __webpack_public_path__ + "img/BVL-Logo-Small@2x.279a1e84.png";